import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import Transaction from "./transaction";
import {translatedTexts} from "../../reducers/translated-texts-store";

function mapStateToProps(state) {
  return {
    transactionRequest: state.transactionRequest,
    domainDetails: state.domainDetails,
    transactions: state.transactions,
    dealerAccount: state.dealerAccount,
    paymentMethod: state.paymentMethod,
    selectedAccordion: state.selectedAccordion,
    bids: state.bids,
    paymentType: state.paymentType,
    errorFlag: state.onSubmitDetails.errorFlag,
    errorFields: state.onSubmitDetails.errorFields,
    createTransactionResponse: state.createTransactionResponse,
    actionType: state.actionType,
    texts :state.translatedTexts
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);
